import {Component} from '@angular/core';
import {BrandService} from 'src/app/shared/services/brand.service';

@Component({
  selector: 'app-sign-posting-nav',
  imports: [],
  templateUrl: './sign-posting-nav.component.html',
  styleUrls: ['../../nav.component.scss'],
})
export class SignPostingNavComponent {
  signPostingLink() {
    return BrandService.getSignPostingLink();
  }
}
